import React from 'react'
import './AboutMockups.css'

const Stage = ({ label, children }) => (
  <div className="am-stage" role="img" aria-label={label}>
    <div className="am-stage__in">{children}</div>
  </div>
)

const Browser = ({ url, children }) => (
  <div className="am-browser" aria-hidden="true">
    <div className="am-browser__bar">
      <i />
      <i />
      <i />
      <span>{url}</span>
    </div>
    <div className="am-browser__body">{children}</div>
  </div>
)

const Phone = ({ children }) => (
  <div className="am-phone" aria-hidden="true">
    <div className="am-phone__notch" />
    <div className="am-phone__screen">{children}</div>
  </div>
)

/* 1. Dashboard */
export const DashboardMock = () => (
  <Stage label="Organiser dashboard overview">
    <Browser url="karamale.com/dashboard">
      <div className="am-dash">
        <aside className="am-side">
          <b className="am-logo">K</b>
          {['Overview', 'Events', 'Sales', 'Promoters', 'Campaigns'].map((t, i) => (
            <span key={t} className={i === 0 ? 'is-on' : ''}>
              <i />
              {t}
            </span>
          ))}
        </aside>
        <div className="am-main">
          <h4>Overview</h4>
          <div className="am-tiles">
            <div>
              <small>Tickets sold</small>
              <strong>1,284</strong>
            </div>
            <div>
              <small>Revenue</small>
              <strong>R86,400</strong>
            </div>
            <div>
              <small>Live events</small>
              <strong>6</strong>
            </div>
          </div>
          <div className="am-panel">
            <small>Sales this week</small>
            <div className="am-bars">
              {[38, 52, 34, 68, 58, 84, 96].map((h, i) => (
                <span key={i} style={{ height: `${h}%` }} className={i === 6 ? 'is-hot' : ''} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Browser>
  </Stage>
)

/* 2. Create an event */
export const CreateEventMock = () => (
  <Stage label="Create an event form">
    <Browser url="karamale.com/dashboard/create">
      <div className="am-form">
        <h4>Create an event</h4>
        <label>
          <small>Event name</small>
          <span>Summer Sunset Live</span>
        </label>
        <div className="am-row">
          <label>
            <small>Date</small>
            <span>14 Dec 2026</span>
          </label>
          <label>
            <small>Starts</small>
            <span>18:00</span>
          </label>
        </div>
        <label>
          <small>Venue</small>
          <span>Montecasino, Johannesburg</span>
        </label>
        <div className="am-tix">
          <div>
            <b>General</b>
            <em>R120</em>
          </div>
          <div>
            <b>VIP</b>
            <em>R350</em>
          </div>
          <div className="am-tix__add">+ Add ticket type</div>
        </div>
        <div className="am-btn">Create event</div>
      </div>
    </Browser>
  </Stage>
)

/* 3. Listed event (mobile) */
export const ListedEventMock = () => (
  <Stage label="Your event listed on the Karamale landing page">
    <Phone>
      <div className="am-app">
        <div className="am-app__top">
          <b>Karamale</b>
          <span className="am-app__search">Search events</span>
        </div>
        <div className="am-ev">
          <div className="am-ev__img">
            <span>Music</span>
          </div>
          <div className="am-ev__body">
            <b>Summer Sunset Live</b>
            <small>Montecasino, Johannesburg</small>
            <div className="am-ev__foot">
              <em>Sat 14 Dec · 18:00</em>
              <span>Get tickets</span>
            </div>
          </div>
        </div>
        <div className="am-ev am-ev--peek">
          <div className="am-ev__img am-ev__img--b" />
        </div>
      </div>
    </Phone>
  </Stage>
)

/* 4. Revenue */
export const RevenueMock = () => (
  <Stage label="Revenue analytics">
    <div className="am-card">
      <div className="am-card__head">
        <div>
          <small>Total revenue</small>
          <strong>R86,400</strong>
        </div>
        <span className="am-chip">+18%</span>
      </div>
      <svg viewBox="0 0 200 80" preserveAspectRatio="none" className="am-chart" aria-hidden="true">
        <defs>
          <linearGradient id="am-rev" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#d91f2d" stopOpacity="0.35" />
            <stop offset="1" stopColor="#d91f2d" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          d="M0,62 C20,58 30,40 50,44 S80,60 100,36 S140,20 160,26 S190,8 200,6 L200,80 L0,80 Z"
          fill="url(#am-rev)"
        />
        <path
          d="M0,62 C20,58 30,40 50,44 S80,60 100,36 S140,20 160,26 S190,8 200,6"
          fill="none"
          stroke="#d91f2d"
          strokeWidth="2.2"
          strokeLinecap="round"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
      <div className="am-axis">
        {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((d) => (
          <span key={d}>{d}</span>
        ))}
      </div>
    </div>
  </Stage>
)

/* 5. Sales progress */
export const SalesMock = () => (
  <Stage label="Sales progress by ticket category">
    <div className="am-card">
      <div className="am-card__head">
        <div>
          <small>Tickets left</small>
          <strong>260</strong>
        </div>
        <span className="am-chip am-chip--ink">640 / 900 sold</span>
      </div>
      {[
        ['General', 412, 600],
        ['VIP', 188, 250],
        ['VVIP', 40, 50],
      ].map(([name, sold, total]) => (
        <div className="am-prog" key={name}>
          <div>
            <b>{name}</b>
            <small>
              {sold} / {total}
            </small>
          </div>
          <div className="am-prog__track">
            <span style={{ width: `${(sold / total) * 100}%` }} />
          </div>
        </div>
      ))}
    </div>
  </Stage>
)

/* 6. Performance: today vs yesterday */
const TODAY = [20, 34, 28, 52, 60, 78, 70]
const YEST = [26, 30, 40, 44, 50, 58, 55]

export const PerformanceMock = () => (
  <Stage label="Performance, today compared with yesterday">
    <div className="am-card">
      <div className="am-card__head">
        <div>
          <small>Today</small>
          <strong>R14,200</strong>
        </div>
        <span className="am-chip">+12% vs yesterday</span>
      </div>
      <svg viewBox="0 0 210 80" className="am-chart" aria-hidden="true">
        {TODAY.map((t, i) => (
          <g key={i} transform={`translate(${i * 30 + 6},0)`}>
            <rect x="0" y={76 - YEST[i]} width="10" height={YEST[i]} rx="3" fill="#ffc9c4" />
            <rect x="12" y={76 - t} width="10" height={t} rx="3" fill="#d91f2d" />
          </g>
        ))}
      </svg>
      <div className="am-legend">
        <span>
          <i className="is-today" />
          Today
        </span>
        <span>
          <i className="is-yest" />
          Yesterday
        </span>
      </div>
    </div>
  </Stage>
)
